import ProductCatalog from './ProductCatalog'

export default ProductCatalog
